import QuickCraftRadioGroup from "./QuickCraftRadioGroup";

const QuickCraftBlocks = ({ data, choosedOptions, selectHandler }) => {
  return (
    <ul className="craft-block__steps">
      {data.map((itemMain) => {
        const choosedOption = choosedOptions.find(
          (option) => option.label === itemMain.label
        );

        return (
          <li className="craft-block__step" key={itemMain.label}>
            <p className="craft-block__step-empty">
              <span>{itemMain.label}</span>
            </p>
            <fieldset className="craft-block__shortcut-select">
              <QuickCraftRadioGroup
                label="Collection"
                options={itemMain.card_collections}
                name={`${itemMain.label}_collection`}
                selectedValue={choosedOption?.[`${itemMain.label}_collection`]}
                onChange={(e) => selectHandler(e, itemMain)}
              />
              <QuickCraftRadioGroup
                label="Rarity"
                options={itemMain.rarities}
                name={`${itemMain.label}_rarity`}
                selectedValue={choosedOption?.[`${itemMain.label}_rarity`]}
                onChange={(e) => selectHandler(e, itemMain)}
              />
            </fieldset>
          </li>
        );
      })}
    </ul>
  );
};

export default QuickCraftBlocks;
